<div [hidden]="!active" class="tab__content">
  <ng-content></ng-content>
</div>
